import { userApi } from '../../../apis/userApi';

const state = {
  users: [],
  currentPage: 1,
  totalPages: 1,
  itemsPerPage: 10,
  loading: false,
  error: null
};

const getters = {
  getUsers: (state) => state.users,
  getCurrentPage: (state) => state.currentPage,
  getTotalPages: (state) => state.totalPages,
  isLoading: (state) => state.loading,
  getError: (state) => state.error
};

const actions = {
  async initialize({ dispatch }) {
    console.log('UserManagement module initialize called');
    try {
      await dispatch('fetchUsers', { page: 0, size: 10 });
      console.log('Initial users fetch completed');
    } catch (error) {
      console.error('Error in userManagement initialize:', error);
    }
  },

  async fetchUsers({ commit }, params) {
    console.log('Fetching users with params:', params);
    commit('SET_LOADING', true);
    try {
      const response = await userApi.getUsers(params);
      console.log('API Response:', response.data.content.content);
      commit('SET_USERS', response?.data?.content?.content);
      commit('SET_TOTAL_PAGES', response?.data?.content?.page?.totalPages);
      commit('SET_CURRENT_PAGE', params.page + 1);
    } catch (error) {
      console.error('Error fetching users:', error);
      commit('SET_ERROR', error.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async createUser({ dispatch }, userData) {
    try {
      const response = await userApi.createUser(userData);
      if (response.data.code === 'SUCCESS') {
        dispatch('fetchUsers', {
          page: 0,
          size: 10,
          sort: 'seq,desc'
        });
        return response.data.data;
      }
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  },

  async updateUser({ dispatch }, { userId, userData }) {
    try {
      const response = await userApi.updateUser(userId, userData);
      if (response.data.code === 'SUCCESS') {
        dispatch('fetchUsers', {
          page: 0,
          size: 10,
          sort: 'seq,desc'
        });
        return response.data.data;
      }
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  },

  async deleteUser({ dispatch }, userId) {
    try {
      const response = await userApi.deleteUser(userId);
      if (response.data.code === 'SUCCESS') {
        dispatch('fetchUsers', {
          page: 0,
          size: 10,
          sort: 'seq,desc'
        });
      }
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error;
    }
  }
};

const mutations = {
  SET_USERS(state, users) {
    state.users = users;
  },
  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page;
  },
  SET_TOTAL_PAGES(state, total) {
    state.totalPages = total;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
